module.exports = __webpack_public_path__ + "static/media/mnt2.081f1cd6.jpg";